const isDev = (): boolean =>
    process.env.NODE_ENV === 'development' ||
    process.env.REACT_APP_ENABLE_DEV_TOOLS === 'true';

const isTest = (): boolean => process.env.NODE_ENV === 'test';

export { isDev, isTest };
